import { styled } from '@mui/material';

export const Root = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  gap: 24,
  width: 352,
});
